<div class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="modalTitle" style="display: block;" aria-modal="true">
  <div class="modal-dialog modal-dialog-scrollable custom-modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalTitle">
          {{title}}
        </h4>
        <button type="button" class="close" (click)="close(false)" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row" *ngIf="merchantBillReports?.length > 0">
          <div class="col-12">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped">
              <thead>
                <tr>
                  <th>MerchantName</th>
                  <th>CardAcceptor</th>
                  <th>TerminalID</th>
                  <th>SerialNumber</th>
                  <th>ActivationDate</th>
                  <th>Active</th>
                  <th>Days</th>
                  <th>DateStart</th>
                  <th>DateEnd</th>
                  <th>Transaction</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr scope="col" *ngFor="let s of merchantBillReports">
                  <td>{{s.merchantName}}</td>
                  <td>{{s.cardAcceptor}}</td>
                  <td>{{s.terminalID}}</td>
                  <td>{{s.serialNumber}}</td>
                  <td>{{s.activationDate | date:'dd/MM/yyyy'}}</td>
                  <td>{{s.isActive}}</td>
                  <td>{{s.days}}</td>
                  <td>{{s.dateStart | date:'dd/MM/yyyy'}}</td>
                  <td>{{s.dateEnd | date:'dd/MM/yyyy'}}</td>
                  <td>{{s.transaction}}</td>
                  <td>{{s.value}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-info waves-effect waves-light mr-1" (click)="close(true)">{{acceptButtonText}}</button>
        <button type="button" *ngIf="showCancel" class="btn btn-secondary" (click)="close(false)">{{cancelButtonText}}</button>
      </div>
    </div>
  </div>
</div>


